import styled from "styled-components";

export const Block = styled.div`
    background: ${props => props.theme.tertiary};
    padding: 1em;
    margin: ${props => props.margin || "1em 0"};
    position: relative;
    overflow: ${props => props.overflow || "auto"};
    color: ${props => props.theme.secondary};

    a {
        text-decoration: none;
    }
    ul {
        margin: 0;
    }
    li {
        margin: 0;
    }

    ${props =>
        !props.hasRowSpans &&
        `tr:last-child {
        border: none;
    }`}
`;
